import { render } from "./Solution.vue?vue&type=template&id=286c3982&scoped=true"
import script from "./Solution.vue?vue&type=script&lang=js"
export * from "./Solution.vue?vue&type=script&lang=js"

import "./Solution.vue?vue&type=style&index=0&id=286c3982&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286c3982"]])

export default __exports__